<template>
<section>
  <AboutTop/>
  <AboutDescription/>
  <Tutorial/>
</section>  
</template>

<script>
import AboutTop from './AboutTop'
import AboutDescription from './AboutDescription'
import Tutorial from './Tutorial'

export default {
  components: {
    AboutTop, AboutDescription, Tutorial
  }
}
</script>


